import React from 'react';

// Material UI
import Fab from '@mui/material/Fab';
import Add from '@mui/icons-material/Add'

import useStyles from './styles';

const CreateButton = ({ label, ...rest }) => {
    const { classes } = useStyles();

    return (
        <div className={classes.root}>
            <Fab 
                color='primary' 
                className={classes.fab}
                variant="extended" {...rest}
            >
                <Add />&nbsp;{ label || 'Crear'}
            </Fab>
        </div>
    )
}

export default CreateButton;